import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setBackButtonUrl } from '../uiSlice';
import FutureGame from '../future/FutureGame';

function MainPage() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setBackButtonUrl('/login?&save=true'));
  }, [dispatch]);

  // Theme fetch lives in FutureGame so every /main visit loads the latest
  // selected theme (admin saves after login are not stuck behind idle status).
  return <FutureGame />;
}

export default MainPage;
